import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TextInput } from './Input';
import { Grid, Typography } from '@mui/material';
import {MaskInput} from './MaskInput'
import { useContext } from 'react';
import { AppContext } from '../context';
import Alert from './Alert';

interface DialogProps {
    isOpen: boolean;
    handleClose: () => void;
}

export default function AddBeneficiaries({isOpen, handleClose}: DialogProps) {
    const { totalPercentage, setBeneficiaries, calcTotalOfPercentage, beneficiaries } = useContext<any>(AppContext);

    const [openAlert, setOpenAlert] = React.useState<boolean>(false)
    const [alertMessage, setAlertMessage] = React.useState<string>('')
    const [name, setName] = React.useState('')
    const [kinship, setKinship] = React.useState('')
    const [percentageToReceive, setPercentageToReceive] = React.useState('')

    const cleanState = () => {
        setName('')
        setKinship('')
        setPercentageToReceive('')
    }

    const handleCloseAlert = () => {
        setOpenAlert(false)
    }

    const handleSave = (addAnother = false) => {
        console.log(percentageToReceive)
        const percentage = parseFloat(percentageToReceive)
        console.log(percentage)
        const beneficiarie = {
            name,
            kinship,
            percentage
        }
        if (addAnother) {
            const isPercentageValid = calcTotalOfPercentage(percentage)
            if (isPercentageValid) {
                setBeneficiaries([...beneficiaries, beneficiarie])
                cleanState()
            } else {
                setAlertMessage('A porcentagem total nao pode ser maior que 100%!')
                setOpenAlert(true)
            }
        } else {
            const isPercentageValid = calcTotalOfPercentage(percentage)
            if (isPercentageValid) {
                setBeneficiaries([...beneficiaries, beneficiarie])
                cleanState()
                handleClose()
            } else {
                setAlertMessage('A porcentagem total nao pode ser maior que 100%!')
                setOpenAlert(true)
            }
        }
    }

  return (
    <form>
      <Dialog open={isOpen} onClose={handleClose}>
        <DialogTitle>Adicionar Beneficiário</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{display: 'flex', justifyContent: 'space-between'}}>
            <Typography>Informe os dados do Beneficiário:</Typography>
            <Typography>Total destribuído: {totalPercentage}%</Typography>
          </DialogContentText>
        <Alert message={alertMessage} status={openAlert} handle={handleCloseAlert}/>
        <Grid 
        container 
        rowSpacing={3} 
        columnSpacing={1}>
            
        <Grid item md={4}>
            <TextInput label={'Nome'} id={'name'} handle={setName} value={name}/>
        </Grid>
        <Grid item md={4}>
            <TextInput label={'Grau de parentesco'} id={'kinship'} handle={setKinship} value={kinship}/>
        </Grid>
        <Grid item md={4}>
            <MaskInput label={'Porcentagem a receber'} id={'percentageToReceive'} mask="99.99%" handle={setPercentageToReceive} value={percentageToReceive}/>
        </Grid>
           
      </Grid>
       
          
          
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleSave(true)}>Salvar e adicionar outro</Button>
          <Button onClick={() => handleSave(false)}>Salvar</Button>
          <Button onClick={handleClose}>Cancelar</Button>
        </DialogActions>
        
      </Dialog>
    </form>
  );
}